import { useMemo, useState } from "react";

import createContextFactory from "@Utils/factory";

function useCollapseFactory() {
  const [collapseId, setCollapseId] = useState(null)

  return useMemo(() => ({
    collapseId, setCollapseId,
  }), [collapseId, setCollapseId])
}

const {
  Provider: CollapseProvider,
  useContext: useCollapse,
} = createContextFactory(useCollapseFactory)

export {
  useCollapse,
  CollapseProvider,
}
